export const InputVerficationKeyTypes = {
    text: 'text',
    tel: 'tel',
    email: 'email',
    homePhone: 'homePhone'
};
